import { Box, Stack, SxProps, useTheme } from "@mui/material";
import Text from "../Text";
import { FC } from "react";
import emptyStateImg from "./img/empty-state-img.png";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  sx?: SxProps;
  text?: string;
}

const EmptyState: FC<EmptyStateProps> = ({ sx, text }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" sx={sx}>
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
        }}
      >
        <Box
          component="img"
          src={emptyStateImg}
          alt={t("noDataToDisplay")}
          width="200px"
          height="auto"
          display="block"
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -2,
            left: 0,
            width: "100%",
            height: "52%",
            background: `linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${theme.palette.grey[500]} 93%)`,
          }}
        />
      </Box>

      <Text variant="h2">{text || t("noDataToDisplay")}</Text>
    </Stack>
  );
};

export default EmptyState;
